import Vue from "vue";

const filterAppendBackend = (value: string | null): string => {
  if (value === null || value.trim().length === 0) return "";
  return "<br/>" + value;
};

Vue.filter("appendBackend", filterAppendBackend);

export { filterAppendBackend };
